import * as qplsService from '../../services/Qpls/qplsService.js';
import {createDialogActions} from '../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => qplsService.setAcceptanceRequest,
  },
});


